import { TrialCheckoutGate } from './TrialCheckoutGate';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import { PageLoader } from '../ui/PageLoader';

interface AuthGuardProps {
  children: React.ReactNode;
  /**
   * When true, also require the user's email to be verified. Used to gate
   * the closed-beta app surface so an attacker who guesses an invite code
   * still can't reach gated content without controlling the email address.
   */
  requireEmailVerified?: boolean;
}

export function AuthGuard({ children, requireEmailVerified = false }: AuthGuardProps) {
  const user = useAuthStore(s => s.user);
  const initialized = useAuthStore(s => s.initialized);

  // Wait for the Supabase session probe to finish before deciding. Without
  // this, every refresh would briefly bounce the user to /login because the
  // user object hasn't been hydrated yet on the first render.
  if (!initialized) return <PageLoader />;

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requireEmailVerified && !user.email_confirmed_at) {
    return <Navigate to="/verify-email" replace />;
  }

  return <TrialCheckoutGate>{children}</TrialCheckoutGate>;
}
